import { Controller } from "stimulus"

export default class extends Controller {
  static targets = ['locationType', 'resident', 'unit', 'permissionToEnter', 'pet', 'entryNotes']

  connect() {
    if (this.hasLocationTypeTarget) {
      $(this.locationTypeTarget).on('select2:select', () => {
        this.locationSelect2Changed()
      })
      $(this.locationTypeTarget).trigger('select2:select')
    }

    if (this.hasUnitTarget) {
      $(this.unitTarget).on('select2:select', () => {
        this.unitChanged()
      })
      $(this.unitTarget).trigger('select2:select')
    }
  }

  locationSelect2Changed() {
    // We have to set/unset `disabled` because of how Rails forms work
    if (this.locationTypeTarget.value === 'unit') {
      $(this.unitTarget).parent().show().find('select').attr('disabled', false)
      const selectedText = $(this.unitTarget).find('option:selected').text()

      if (this.unitTarget.value && !selectedText.includes('Vacant')) {
        // Only force-refetch after Location was toggled away (fields hidden). On edit
        // connect(), resident is already selected server-side — force would wipe it.
        const residentFieldsHidden = $(this.residentTarget).parent().is(':hidden')
        if (residentFieldsHidden) {
          this.unitChanged({ force: true })
        } else {
          this.showResidentFields()
        }
      } else {
        this.hideResidentFields()
      }
    } else {
      $(this.unitTarget).parent().hide().find('select').attr('disabled', true)
      this.hideResidentFields()
    }
  }

  showResidentFields() {
    $(this.residentTarget).parent().show().find('select').attr('disabled', false)
    $(this.permissionToEnterTarget).show().find('input').attr('disabled', false)
    $(this.petTarget).show().find('input').attr('disabled', false)
  }

  hideResidentFields() {
    $(this.residentTarget)
      .attr('data-resident-unit-id', this.unitTarget.value)
      .parent()
      .hide()
      .find('select')
      .attr('disabled', true)

    $(this.permissionToEnterTarget).hide().find('input').attr('disabled', true)
    $(this.petTarget).hide().find('input').attr('disabled', true)
    this.clearPetPrefill()
  }

  unitChanged({ force = false } = {}) {
    const unitId = this.unitTarget.value
    const currentUnitId = this.residentTarget.dataset.residentUnitId

    if (unitId && (force || currentUnitId !== unitId)) {
      $.get({
        url: `/api/units/${unitId}/residents`,
        success: (response) => {
          if (response.residents && response.residents.length > 0) {
            this.showResidentFields()
            this.populateResidentOptions(response.residents, unitId)
            this.applyPetPrefill(response)
          } else {
            this.hideResidentFields()
          }
        }
      })
    }
  }

  populateResidentOptions(residents, unitId) {
    const $resident = $(this.residentTarget)
    const previouslySelected = $resident.val()

    // Clear the select2 Prompt text/value
    $resident
      .parent()
      .find('select')
      .empty()
      .append($('<option>', { text: 'Select Resident', value: '' }))
      .trigger('change')

    // Clear the select2 dropdown and add the options
    $resident.empty().append($('<option>', { text: 'Select Resident', value: '' }))

    residents.forEach((resident) => {
      $resident.append($('<option>', { text: resident[0], value: resident[1] }))
    })

    if (previouslySelected && residents.some((resident) => String(resident[1]) === String(previouslySelected))) {
      $resident.val(previouslySelected)
    }

    $resident.attr('data-resident-unit-id', unitId).trigger('change')
  }

  applyPetPrefill(response) {
    if (!this.prefillPetsEnabled || !this.hasPetTarget) return

    if (response.has_pets) {
      this.setPetRadio(true)
      this.setEntryNotes(response.entry_notes || '')
    } else {
      this.clearPetPrefill()
    }
  }

  clearPetPrefill() {
    if (!this.prefillPetsEnabled || !this.hasPetTarget) return

    this.setPetRadio(false)
    this.setEntryNotes('')
  }

  setPetRadio(hasPet) {
    const value = hasPet ? 'true' : 'false'
    $(this.petTarget)
      .find(`input.pet-status[value="${value}"]`)
      .prop('checked', true)
      .trigger('change')
  }

  setEntryNotes(notes) {
    if (this.hasEntryNotesTarget) {
      this.entryNotesTarget.value = notes
    }
  }

  get prefillPetsEnabled() {
    return this.data.get('prefillPets') === 'true'
  }
}
